(function(){
  'use strict';

  window.dataLayer = window.dataLayer || [];

  function pushEvent(name, payload){
    try {
      var data = Object.assign({}, payload || {});
      data.event = name;
      data.event_version = 'ae_tracking_v2_2026_09_20';
      data.page_path = window.location.pathname;
      data.page_title = document.title;
      window.dataLayer.push(data);

      if(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function'){
        Shopify.analytics.publish('ae_' + name, data);
      }
    } catch(e) {}
  }

  function initReveal(){
    var els = document.querySelectorAll('.ae-reveal');
    if(!els.length) return;
    if(!('IntersectionObserver' in window)){
      els.forEach(function(el){ el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function(el){ io.observe(el); });
  }

  /* CASA FACILE v18 — native catalog links. */
  function initCasaFacileCatalogLinks(){
    if(window.location.pathname !== '/pages/servizi-elettricista-casa-facile') return;

    var collectionRoutes = {
      'Domotica & Smart Home': '/collections/domotica-smart-home-monza-brianza-casa-facile',
      'Illuminazione': '/collections/casa-facile',
      'Impianto & Sicurezza': '/collections/casa-facile-impianto-sicurezza'
    };

    document.querySelectorAll('.cfm-official-card--collection').forEach(function(card){
      var titleNode = card.querySelector('.cfm-official-card__header h3');
      var title = titleNode ? titleNode.textContent.trim() : '';
      var route = collectionRoutes[title];
      if(!route) return;

      card.querySelectorAll('a[href]').forEach(function(link){
        link.setAttribute('href', route);
        link.removeAttribute('target');
        link.removeAttribute('rel');
        link.setAttribute('data-ae-conversion', 'casa_facile_collection');
      });
    });

    document.querySelectorAll('.cfm-official-card--product a[href^="/products/"]').forEach(function(link){
      link.removeAttribute('target');
      link.removeAttribute('rel');
      link.setAttribute('data-ae-conversion', 'casa_facile_product');
    });

    document.querySelectorAll('.cfm-nav a[href="/cart"], .cf-mobilebar a[href="/cart"], .cfm-mobile-sticky a[href="/cart"]').forEach(function(link){
      link.setAttribute('href', '/cart');
      link.removeAttribute('target');
      link.removeAttribute('rel');
      link.setAttribute('data-ae-conversion', 'casa_facile_cart');
    });

    if(!document.getElementById('cf-native-card-links-v18')){
      var style = document.createElement('style');
      style.id = 'cf-native-card-links-v18';
      style.textContent = '\n        html body.template-casa-facile-shop .cfm-official-card--collection,\n        html body.template-casa-facile-shop .cfm-official-card--product{position:relative!important;cursor:pointer}\n        html body.template-casa-facile-shop .cfm-official-card--collection .cfm-official-card__header h3 a,\n        html body.template-casa-facile-shop .cfm-official-card--product .cfm-official-card__header h3 a{position:static!important}\n        html body.template-casa-facile-shop .cfm-official-card--collection .cfm-official-card__header h3 a::after,\n        html body.template-casa-facile-shop .cfm-official-card--product .cfm-official-card__header h3 a::after{content:"";position:absolute;inset:0;z-index:1;border-radius:inherit}\n        html body.template-casa-facile-shop .cfm-official-card__cta{position:relative!important;z-index:3!important}\n        html body.template-casa-facile-shop .cfm-official-card__header h3 a:focus-visible::after{outline:3px solid #102f3a;outline-offset:3px}\n      ';
      document.head.appendChild(style);
    }
  }

  function initConversionTracking(){
    document.addEventListener('click', function(e){
      var link = e.target.closest('a[href], [data-ae-conversion]');
      if(!link) return;
      var href = link.getAttribute('href') || '';
      var hrefLower = href.toLowerCase();
      var explicitSource = link.getAttribute('data-ae-conversion');
      var source = explicitSource || 'theme_link';
      var ctaText = ((link.getAttribute('aria-label') || link.textContent || '').replace(/\s+/g, ' ').trim()).slice(0, 100);

      if(hrefLower.indexOf('tel:') === 0){
        pushEvent('click_call', {channel:'phone', source:source, cta_text:ctaText});
      } else if(hrefLower.indexOf('wa.me') !== -1 || hrefLower.indexOf('whatsapp') !== -1){
        pushEvent('click_whatsapp', {channel:'whatsapp', source:source, cta_text:ctaText});
      } else if(hrefLower.indexOf('mailto:') === 0){
        pushEvent('click_email', {channel:'email', source:source, cta_text:ctaText});
      } else if(hrefLower.indexOf('#preventivo') !== -1 || hrefLower.indexOf('/pages/contatti') !== -1){
        pushEvent('click_quote', {cta_type:'quote_request', source:source, cta_text:ctaText});
      } else if(explicitSource){
        pushEvent('click_cta', {cta_type:'navigation', source:source, cta_text:ctaText});
      }
    }, true);

    document.addEventListener('focusin', function(e){
      var field = e.target;
      var form = field && field.closest ? field.closest('form') : null;
      if(!form || form.dataset.aeLeadStarted === '1') return;
      var action = (form.getAttribute('action') || '').toLowerCase();
      if(action.indexOf('/contact') !== -1 || form.querySelector('[name^="contact"]')){
        form.dataset.aeLeadStarted = '1';
        var source = form.id === 'ae-home-contact-form' ? 'home_quote_form' : 'theme_contact_form';
        pushEvent('lead_form_start', {form_name:'quote_request', source:source});
      }
    }, true);

    document.addEventListener('submit', function(e){
      var form = e.target;
      if(!form) return;
      var action = (form.getAttribute('action') || '').toLowerCase();
      if(action.indexOf('/contact') !== -1 || form.querySelector('[name^="contact"]')){
        var source = form.id === 'ae-home-contact-form' ? 'home_quote_form' : 'theme_contact_form';
        pushEvent('lead_form_submit_attempt', {form_name:'quote_request', source:source});
        try {
          sessionStorage.setItem('ae_contact_submit_attempt', JSON.stringify({ts:Date.now(), source:source}));
        } catch(e) {}
      }
    }, true);

    var success = document.querySelector('[data-ae-form-status="success"]');
    var error = document.querySelector('[data-ae-form-status="error"]');
    if(success || error){
      var statusNode = success || error;
      var statusForm = statusNode.closest('form');
      var statusSource = statusForm && statusForm.id === 'ae-home-contact-form' ? 'home_quote_form' : 'theme_contact_form';
      var attempt = null;
      var storageUsable = true;

      try {
        var raw = sessionStorage.getItem('ae_contact_submit_attempt');
        if(raw) attempt = JSON.parse(raw);
        sessionStorage.removeItem('ae_contact_submit_attempt');
      } catch(e) {
        storageUsable = false;
      }

      if(attempt && attempt.source) statusSource = attempt.source;

      var recentAttempt = !storageUsable || (attempt && attempt.ts && (Date.now() - attempt.ts) < 600000);
      if(success && recentAttempt){
        pushEvent('lead_form_submit', {form_name:'quote_request', source:statusSource, submission_status:'success'});
      } else if(error && recentAttempt){
        pushEvent('lead_form_error', {form_name:'quote_request', source:statusSource, submission_status:'error'});
      }

      window.setTimeout(function(){
        try {
          statusNode.focus({preventScroll:true});
        } catch(e) {
          try { statusNode.focus(); } catch(ignore) {}
        }
      }, 60);
    }

    var aeScrollMarks = {25:false,50:false,75:false};
    function aeTrackScrollDepth(){
      var doc = document.documentElement;
      var scrollable = Math.max(doc.scrollHeight - window.innerHeight, 0);
      if(scrollable <= 0) return;
      var percent = Math.min(100, Math.round((window.scrollY / scrollable) * 100));
      [25,50,75].forEach(function(mark){
        if(!aeScrollMarks[mark] && percent >= mark){
          aeScrollMarks[mark] = true;
          pushEvent('scroll_depth', {percent_scrolled:mark});
        }
      });
      if(aeScrollMarks[25] && aeScrollMarks[50] && aeScrollMarks[75]){
        window.removeEventListener('scroll', aeTrackScrollDepth);
      }
    }
    window.addEventListener('scroll', aeTrackScrollDepth, {passive:true});

    if(document.querySelector('.ae-top-conversion')){
      pushEvent('ae_top_conversion_bar_loaded', {source:'top_conversion_bar'});
    }
  }

  function init(){
    initReveal();
    initCasaFacileCatalogLinks();
    initConversionTracking();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* === CASA FACILE V18.1 — MOBILE COLLECTION AUTOPLAY FAST INTRO — 2026-09-12 === */
(function(){
  'use strict';

  if(window.__cfCollectionAutoplayV181) return;
  window.__cfCollectionAutoplayV181 = true;

  var mobile = window.matchMedia('(max-width: 749px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var track = null;
  var timer = 0;
  var resumeTimer = 0;
  var observer = null;
  var inView = false;
  var wasInView = false;
  var introPlayed = false;
  var pausedUntil = 0;
  var fastIntroDelayMs = 180;
  var fastIntervalMs = 780;
  var fastSteps = 2;
  var slowIntervalMs = 4800;
  var interactionPauseMs = 8000;

  function getCards(){
    if(!track) return [];
    return Array.prototype.filter.call(track.children, function(item){
      return item.classList && item.classList.contains('cfm-official-card--collection');
    });
  }

  function getStep(){
    var cards = getCards();
    if(!cards.length) return 0;
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return cards[0].getBoundingClientRect().width + gap;
  }

  function stop(){
    if(timer) window.clearTimeout(timer);
    timer = 0;
  }

  function canRun(){
    return !!(
      track &&
      track.isConnected &&
      mobile.matches &&
      !reduced.matches &&
      !document.hidden &&
      inView &&
      Date.now() >= pausedUntil &&
      !track.matches(':focus-within')
    );
  }

  function advance(){
    if(!canRun()) return false;
    var cards = getCards();
    var step = getStep();
    if(cards.length < 2 || !step) return false;

    var current = Math.round(track.scrollLeft / step);
    current = Math.max(0, Math.min(cards.length - 1, current));
    var next = (current + 1) % cards.length;

    track.scrollTo({
      left: next * step,
      behavior: 'smooth'
    });
    return true;
  }

  function startSlow(){
    stop();
    if(!canRun()) return;

    function tick(){
      if(!canRun()){
        stop();
        return;
      }
      advance();
      timer = window.setTimeout(tick, slowIntervalMs);
    }

    timer = window.setTimeout(tick, slowIntervalMs);
  }

  function playFastIntro(){
    stop();
    if(!canRun()) return;
    introPlayed = true;

    var remaining = fastSteps;
    function burst(){
      if(!canRun()){
        stop();
        return;
      }

      advance();
      remaining -= 1;

      if(remaining > 0){
        timer = window.setTimeout(burst, fastIntervalMs);
      } else {
        timer = window.setTimeout(startSlow, 1000);
      }
    }

    timer = window.setTimeout(burst, fastIntroDelayMs);
  }

  function pauseForInteraction(){
    pausedUntil = Date.now() + interactionPauseMs;
    stop();
    if(resumeTimer) window.clearTimeout(resumeTimer);
    resumeTimer = window.setTimeout(function(){
      pausedUntil = 0;
      startSlow();
    }, interactionPauseMs);
  }

  function observeTrack(){
    if(observer){
      observer.disconnect();
      observer = null;
    }

    inView = true;
    wasInView = false;
    if(!('IntersectionObserver' in window)){
      if(!introPlayed) playFastIntro();
      else startSlow();
      return;
    }

    inView = false;
    observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.target !== track) return;

        var visible = entry.isIntersecting && entry.intersectionRatio >= 0.18;
        var entered = visible && !wasInView;
        inView = visible;
        wasInView = visible;

        if(!visible){
          stop();
          return;
        }

        if(entered && !introPlayed){
          playFastIntro();
        } else {
          startSlow();
        }
      });
    }, { threshold:[0, 0.18, 0.5] });
    observer.observe(track);
  }

  function bind(){
    var nextTrack = document.querySelector('#soluzioni.cfm-cards--collections .cfm-card-grid');
    if(!nextTrack){
      stop();
      track = null;
      return;
    }

    track = nextTrack;
    track.dataset.cfAutoplayV13 = '1';

    if(track.dataset.cfAutoplayV181 !== '1'){
      track.dataset.cfAutoplayV181 = '1';
      track.addEventListener('pointerdown', pauseForInteraction, {passive:true});
      track.addEventListener('touchstart', pauseForInteraction, {passive:true});
      track.addEventListener('wheel', pauseForInteraction, {passive:true});
      track.addEventListener('keydown', pauseForInteraction);
      track.addEventListener('focusin', pauseForInteraction);
      track.addEventListener('focusout', function(){
        window.setTimeout(startSlow, 250);
      });
    }

    observeTrack();
  }

  function refresh(){
    stop();
    if(resumeTimer) window.clearTimeout(resumeTimer);
    introPlayed = false;
    pausedUntil = 0;
    bind();
  }

  document.addEventListener('visibilitychange', function(){
    if(document.hidden) stop();
    else if(inView) startSlow();
  });

  document.addEventListener('shopify:section:load', function(){
    window.setTimeout(refresh, 80);
  });

  function syncMotion(){
    if(!mobile.matches || reduced.matches){
      stop();
      return;
    }
    if(inView){
      if(!introPlayed) playFastIntro();
      else startSlow();
    }
  }

  if(mobile.addEventListener) mobile.addEventListener('change', syncMotion);
  if(reduced.addEventListener) reduced.addEventListener('change', syncMotion);

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', bind, {once:true});
  } else {
    bind();
  }
})();
